import { render, staticRenderFns } from "./BloggerRankingChannel.vue?vue&type=template&id=3f255e44&"
import script from "./BloggerRankingChannel.vue?vue&type=script&lang=js&"
export * from "./BloggerRankingChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports